import $ from 'jquery';

export default class NavBar {
    constructor() {
        $('.js-header__nav-trigger').on('click', function() {
            $(this).toggleClass('is-active');
            $('.js-header__nav-trigger-icon').toggleClass('icon-menu icon-close-icon');

            $('.js-nav').slideToggle();
        });

        $('.js-primary-nav .menu-item-has-children').hover(function() {
            $(this).find('.sub-menu').fadeToggle();
        });

        $('.js-nav__mobile-subnav-toggle').on('click', function() {
            const $this = $(this);

            $this.next().slideToggle();
            $this.toggleClass('is-active');
        });
    };
};
